module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('mo-header'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('center', [_c('img', {
    staticStyle: {
      "padding-top": "7%"
    },
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}